// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 52,
  argument: "The general corruption of man before the coming of Christ.",
  verses: [
    { n: 1, text: "Unto the end, for Maeleth, understanding to David. The fool said in his heart: There is no God." },
    { n: 2, text: "They are corrupted, and become abominable in iniquities: there is none that doth good." },
    { n: 3, text: "God looked down from heaven on the children of men: to see if there were any that did understand, or did seek God." },
    { n: 4, text: "All have gone aside, they are become unprofitable together: there is none that doth good; no, not one." },
    { n: 5, text: "Shall not all the workers of iniquity know, who eat up my people as they eat bread?" },
    { n: 6, text: "They have not called upon God: there have they trembled for fear, where there was no fear. For God hath scattered the bones of them that please men: they have been confounded, because God hath despised them." },
    { n: 7, text: "Who will give out of Sion the salvation of Israel? when God shall bring back the captivity of his people, Jacob shall rejoice, and Israel shall be glad." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Maeleth, or Machalath. A musical instrument, or a chorus of musicians: for St. Jerome renders it, per chorum; (Challoner) and Aquila, \"for dancing.\" Sixtus V, &c., read incorrectly, \"for Amalec.\" — The psalm is nearly the same with the 13th, (Calmet) except", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "(Menochius) — We know not the reason why David gave this second copy, omitting the name of Jehovah. (Berthier) — St. Augustine explains it of the dangers of the latter times. (Worthington) — It seems to speak of the return from captivity,", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
